import moment from 'moment-timezone';

import { getUrlParam } from '../helpers';
import { getAPIUrl } from '../helpers/App';

export const APIfetchUserProfile = () => (
  window.axios.get(getAPIUrl('/user'), {
    headers: {
      'user-timezone': moment.tz.guess(true),
      fsbc: getUrlParam('fsbc'),
    },
  })
    .then(response => (response))
);

export const APIfetchUserProfileById = (userId, params) => (
  window.axios.get(getAPIUrl(`/users/${userId}`), { params })
    .then(response => (response))
);

export const APIfetchUserActions = (userUuid, params) => (
  window.axios.get(getAPIUrl(`/users/${userUuid}/actions`), { params })
    .then(response => (response))
);

export const APIcreateUser = user => (
  window.axios.post(getAPIUrl('/users'), { user })
    .then(response => (response))
);

export const APIupdateUser = user => (
  window.axios.patch(getAPIUrl(`/users/${user.uuid}`), { user })
    .then(response => (response))
);

export const APIupdatePassword = (userUuid, passwords) => (
  window.axios.patch(getAPIUrl(`/users/${userUuid}/password`), { passwords })
    .then(response => (response))
);

export const APIgetUsers = params => (
  window.axios.get(getAPIUrl('/users'), { params })
    .then(response => (response))
);

export const APIgetUserAvatarPreview = file => (
  window.axios.post(getAPIUrl('/users/avatar_preview'), { file })
    .then(response => (response))
);

export const APIgetUserStats = userId => (
  window.axios.get(getAPIUrl(`/users/${userId}/stats`))
    .then(response => (response))
);

export const APIdeactivateUser = (userUuid, targetUserUuid) => (
  window.axios.patch(getAPIUrl(`/users/${userUuid}/deactivate`), { target_user_uuid: targetUserUuid })
    .then(response => (response))
);

export const APIactivateUser = userUuid => (
  window.axios.patch(getAPIUrl(`/users/${userUuid}/activate`))
    .then(response => (response))
);

export const APIgetUserSettings = (userUuid, params) => (
  window.axios.get(getAPIUrl(`/users/${userUuid}/settings`), { params })
    .then(response => (response))
);

export const APIupdateUserSettings = (userUuid, settings) => (
  window.axios.patch(getAPIUrl(`/users/${userUuid}/settings`), { settings })
    .then(response => (response))
);

export const APIgetUserSettingValue = (userUuid, key) => (
  window.axios.get(getAPIUrl(`/users/${userUuid}/settings/${key}`))
    .then(response => (response))
);

export const APIcreateUserSettingValue = (userUuid, key, value) => (
  window.axios.post(getAPIUrl(`/users/${userUuid}/settings/${key}`), { value })
    .then(response => (response))
);

export const APIupdateUserSettingValue = (userUuid, key, value) => (
  window.axios.patch(getAPIUrl(`/users/${userUuid}/settings/${key}`), { value })
    .then(response => (response))
);

export const APIremoveUserSettingValue = (userUuid, key, removeKey) => (
  window.axios.delete(getAPIUrl(`/users/${userUuid}/settings/${key}/${removeKey}`))
    .then(response => (response))
);

export const APIsendWelcomeEmail = userId => (
  window.axios.post(getAPIUrl(`/users/${userId}/welcome`))
    .then(response => (response))
);

export const APIconnectUser = params => (
  window.axios.post(getAPIUrl('/user/connect'), params)
    .then(response => (response))
);

export const APIregisterUser = params => (
  window.axios.post(getAPIUrl('/register'), params)
    .then(response => (response))
);

export const APIgetUserGroups = userId => (
  window.axios.get(getAPIUrl(`/users/${userId}/groups`))
    .then(response => (response))
);

export const APIremove2FA = userId => (
  window.axios.delete(getAPIUrl(`/users/${userId}/2fa`))
    .then(response => (response))
);

export const APIconfirmEmailChange = code => (
  window.axios.post(getAPIUrl('/user/email_change_confirm'), { code })
    .then(response => (response))
);

export const APIcancelEmailChange = () => (
  window.axios.delete(getAPIUrl('/user/email_change_cancel'))
    .then(response => (response))
);

export const APIsendEmailLoginCode = (email) => (
  window.axios.post(getAPIUrl('/email_login_code'), { email })
    .then(response => (response))
);

export const APIvalidateEmailLoginCode = (code) => (
  window.axios.post(getAPIUrl('/email_login_code_validate'), { code })
    .then(response => (response))
);

export const APIunlockUser = userId => (
  window.axios.patch(getAPIUrl(`/users/${userId}/unlock`))
    .then(response => (response))
);

export const APIloadTerms = userId => (
  window.axios.get(getAPIUrl(`/users/${userId}/load_terms`))
    .then(response => (response.data))
);

export const APIacceptTerms = userId => (
  window.axios.patch(getAPIUrl(`/users/${userId}/accept_terms`))
    .then(response => (response))
);

export const APIemptyUserTrash = (fileGroupUuid) => (
  window.axios.post(getAPIUrl('/user/empty_trash'), { file_group_uuid: fileGroupUuid })
    .then(response => (response))
);
